import classNames from "classnames";
import React from "react";

interface Props {
  text: string
  href: string
  type?: "primary" | "secondary" | "tertiary"
  big?: boolean
  fluid?: boolean
  style?: React.CSSProperties
}

const LinkButton = (props: Props) => {
  const classes = classNames("button-new", props.type, {
    big: props.big,
    fluid: props.fluid

  });
  return <a style={props.style} href={props.href} className={classes}>
    {props.text}
  </a>;
};

export default LinkButton;